<!-- 取消快递 -->
<template>
	<div class="container flex flex-column height-all expressClear">
		<el-form ref="expressModeForm" :rules="expressModeRules" :model="formDatas" class="addAreaForm" label-position="left">
			<el-form-item label="快递公司: " prop="logisticsCode" class="flex align-center">
				<el-select v-model="formDatas.logisticsCode" filterable class="m-2" placeholder="请选择快递公司">
					<el-option v-for="item in expressModeOptions" :key="item.code" :label="item.name" :value="item.code" />
				</el-select>
			</el-form-item>
			<el-form-item label="快递单号: " prop="trackNos" class="flex align-center">
				<el-input type="textarea" :rows="5" v-model="formDatas.trackNos" placeholder='请输入快递单号，多个单号可使用","连接'></el-input>
			</el-form-item>
		</el-form>
		<div class="optionBtnDiv">
		  <el-button type="primary" class="editBtn" @click="enterClick">确认回收</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		inject: ['$http', '$api', '$utils', '$userUtils'],
		name: "orderList",
		
		data() {
			return{
				formDatas:{
					logisticsCode:'',
					trackNos:''
				},
				expressModeRules: {
					"logisticsCode": [{
						required: true,
						message: "请选择快递公司",
						trigger: "change"
					}],
					"trackNos":[{
						required: true,
						message: "请输入快递单号",
						trigger: "blur"
					}]
				},
				expressModeOptions:[],
			}
		},
		mounted() {
			this.getSupportExpressOptions();
		},
		methods:{
			/**
			 * 获取快递方式筛选项
			 */
			getSupportExpressOptions() {
				let that = this;
				that.$http.post(that.$api.getCommonDictsApi,{
					type:'快递公司字典'
				}).then(res => {
					if (res.code == 200) {
						that.expressModeOptions = res.data;
					}
				})
			},
			/**
			 * 确认取消
			 */
			enterClick(){
				let that = this;
				that.$refs["expressModeForm"].validate(valid => {
					if(valid){
						that.$loading();
						that.$http.post(that.$api.cancelExpressNumApi,{
							trackNos:that.formDatas.trackNos,
							logisticsCode:that.formDatas.logisticsCode,
						}).then(res => {
							that.$loading().close();
							if (res.code == 200) {
								that.$message.success('操作成功');
								that.$refs['expressModeForm'].resetFields();
							}
						})
					}
				})
			},
		}
	}
</script>

<style>
	.expressClear .el-input__wrapper{
		box-shadow: 0 0 0 1px #dcdfe6 inset !important;
	}
</style>
<style scoped>
	.addAreaForm{
		width: 400px;
	}
	.optionBtnDiv{
		width: 400px;
		display: flex;
		justify-content: center;
	}
	.el-form-item{
		display: flex;
		align-items: flex-start;
	}
</style>